import React, { useState } from 'react';
import '../../scss/_global.scss';

export default function ForgotPassword() {
    const [username, setUsername] = useState('')
    const keyEnter = (event) => {
        if (event.keyCode === 13) {
            loginClick()
        }
    }
    const loginClick = async (event) => {
        /*setSpiner(true);
        const resp = await accessLogic.loginLogic(username,password);
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false);
        if (!resp.error) {
            localStorage.setItem('userToken', resp.data.token)
            window.location.href = resp.url
        }*/
    }
    return (
        <>
            <div className="hold-transition login-page">
                <div className="login-box">
                    <div className="login-logo">
                        <a href="../../index2.html"><b>Recuperar contraseña</b></a>
                    </div>
                    <div className="card">
                        <div className="card-body login-card-body">
                            <div className="login-box-msg">Se enviará un link a su correo registrado para poder cambiar la contraseña</div>
                            <div className="input-group mb-3">
                                <input maxLength="30" minLength="1" onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setUsername(target.value)} type="email" className="form-control" placeholder={global.LOGIN_EMAIL_TXT} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_EMAIL} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button onClick={loginClick} className="btn btn-primary btn-block">Enviar correo de recuperación</button>
                                </div>
                            </div>
                            <div className="social-auth-links text-center mb-3">
                            </div>
                            <div className="mb-1">
                                <a href={global.ROUTE_LOGIN}>Regresar al login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}